// Block `type` strings are the cross-repo wire contract (stored in content_blocks.type and
// inside the block JSON). MUST stay in sync with:
//   kastafiorementalplus-api/src/enums/ContentBlockTypesEnum.ts
//   diapasonmentalplus/src/components/UI/atoms/RichTextEditor/blockTypes.ts
export const BLOCK = {
  HEADER: "header",
  PARAGRAPH: "paragraph",
  LIST: "list",
  TABLE: "table",
  DELIMITER: "delimiter",
  EMBED: "embed",
  IMAGE: "image",
  // Rich section blocks (Rich Content Phase 1)
  HERO: "hero",
  ICON_LINKS: "iconLinks",
  CARDS: "cards",
  CTA_BUTTON: "ctaButton",
  AUDIO: "audio",
  VIDEO: "video",
  // Third-party player/widget embedded by URL — distinct from EMBED, which is
  // @editorjs/embed's paste-only, 13-service block.
  IFRAME: "iframe",
  // Responsive grid of uploaded-video cards (the Videos tab's card, inside content).
  VIDEO_CARDS: "videoCards",
  // Styling completeness set
  SPACER: "spacer",
  CALLOUT: "callout",
  QUOTE: "quote",
} as const;

export type BlockType = (typeof BLOCK)[keyof typeof BLOCK];
